export default __webpack_public_path__ + "static/media/logo_small.232e7fd3.png";